import CustomProfile2ndLine from "./CustomProfile/CustomProfile2ndLine";
import CustomProfile3rdLine from "./CustomProfile/CustomProfile3rdLine";

type CustomProfileType = {
    merchant: any;
    typeDetail: any;
    userInfo: any;
    pointValue: any;
    EYPoint: any;
    expirePoint: any;
};

export default function CustomProfileMain(props: CustomProfileType) {
    return (
        <>
            <div className="detail-text">
                <CustomProfile2ndLine {...props} />
            </div>
            <div className="detail-text">
                <CustomProfile3rdLine {...props} />
            </div>
        </>
    );
}
